// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__sidebar___Wm38h {
  position: fixed;
  z-index: 100;
  width: 50%;
  top: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(19, 39, 48, 0.12);
}
@media (max-width: 991px) {
  .styles__sidebar___Wm38h {
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
}
@media (max-width: 991px) {
  .styles__sidebar___Wm38h::-webkit-scrollbar {
    display: none;
  }
}
.styles__header___IBF57 {
  min-height: 80px;
  max-height: 150px;
  padding: 1em;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  word-break: break-all;
}
.styles__item___fbD9k {
  display: flex;
  padding: 20px;
  border-bottom: 1px solid #eee;
}
.styles__separator___Pg70E {
  border-bottom: 2px solid #ccc;
}
`, "",{"version":3,"sources":["webpack://./src/components/components/Sidebar/styles.less"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,YAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,gBAAA;EACA,8CAAA;AADF;AAGE;EAAA;IACE,kBAAA;IACA,iCAAA;IACA,qBAAA;IACA,wBAAA;EAAF;AACF;AAGA;EACE;IACE,aAAA;EADF;AACF;AAIA;EACE,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,qBAAA;AAFF;AAKA;EACE,aAAA;EACA,aAAA;EACA,6BAAA;AAHF;AAMA;EACE,6BAAA;AAJF","sourcesContent":["@import '../../../shared/variables.less';\n\n.sidebar {\n  position: fixed;\n  z-index: 100;\n  width: 50%;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  background: #fff;\n  box-shadow: @eon-box-shadow;\n\n  @media (max-width: @screen-sm-max) {\n    overflow-y: scroll;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n}\n\n@media (max-width: @screen-sm-max) {\n  .sidebar::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n.header {\n  min-height: 80px;\n  max-height: 150px;\n  padding: 1em;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: @eon-header-text-color;\n  word-break: break-all;\n}\n\n.item {\n  display: flex;\n  padding: 20px;\n  border-bottom: 1px solid #eee;\n}\n\n.separator {\n  border-bottom: 2px solid #ccc;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebar": `styles__sidebar___Wm38h`,
	"header": `styles__header___IBF57`,
	"item": `styles__item___fbD9k`,
	"separator": `styles__separator___Pg70E`
};
export default ___CSS_LOADER_EXPORT___;
